/*
 * Copyright (c) 2024 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * PROPRIETARY/CONFIDENTIAL
 *
 * Use is subject to license terms.
*/

// amznmod_react - To add support for KeplerTurboModule in order to fetch NativeModules, simply import it and extend it to access all the Native layer APIs.

// eslint-disable-next-line import/no-unresolved
import type {KeplerTurboModule} from '@amazon-devices/keplerscript-turbomodule-api';
import {TurboModuleRegistry} from '@amazon-devices/keplerscript-turbomodule-api';

interface NativeRNDeviceInfo extends KeplerTurboModule {
  getHost: () => Promise<string>;
  getHostSync: () => string;
  getUsedMemory: () => Promise<number>;
  getUsedMemorySync: () => number;
  getTotalMemory: () => Promise<number>;
  getTotalMemorySync: () => number;
  getMaxMemory: () => Promise<number>;
  getMaxMemorySync: () => number;
  getTotalDiskCapacity: () => Promise<number>;
  getTotalDiskCapacitySync: () => number;
  getFreeDiskStorage: () => Promise<number>;
  getFreeDiskStorageSync: () => number;
  getBaseOs: () => Promise<string>;
  getBaseOsSync: () => string;
  getSystemManufacturer: () => Promise<string>;
  getSystemManufacturerSync: () => string;
  getUserAgent: () => Promise<string>;
  getUserAgentSync: () => string;
  getBuildId: () => Promise<string>;
  getBuildIdSync: () => string;
  getBootloader: () => Promise<string>;
  getBootloaderSync: () => string;
  getProduct: () => Promise<string>;
  getProductSync: () => string;
  getSerialNumber: () => Promise<string>;
  getSerialNumberSync: () => string;
  getHardware: () => Promise<string>;
  getHardwareSync: () => string;
  getTags: () => Promise<string>;
  getTagsSync: () => string;
  isEmulator: () => Promise<boolean>;
  isEmulatorSync: () => boolean;
  supported32BitAbis: () => Promise<string>;
  supported32BitAbisSync: () => string;
  supported64BitAbis: () => Promise<string>;  supported64BitAbisSync: () => string;
  supportedAbis: () => Promise<string>;
  supportedAbisSync: () => string;
  getFirstInstallTime: () => Promise<number>;
  getFirstInstallTimeSync: () => number;
  getInstallerPackageName: () => Promise<string>;
  getInstallerPackageNameSync: () => string;
  getInstanceId: () => Promise<string>;
  getInstanceIdSync: () => string;
  getLastUpdateTime: () => Promise<number>;
  getLastUpdateTimeSync: () => number;
  getInstallReferrer: () => Promise<string>;
  getInstallReferrerSync: () => string;
}

export default TurboModuleRegistry.getEnforcing<NativeRNDeviceInfo>('DeviceInfoModule');